function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadyForPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10405",
    transform: "translate(-956 -195)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6012",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(956 195)",
    style: {
      fill: "#dbf0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41150",
    d: "M-550.413 244.641v-7.762a1.722 1.722 0 0 1 1.925-1.92h13.312a1.714 1.714 0 0 1 1.885 1.9c0 1.538.006 3.076-.006 4.614 0 .261.044.349.332.347 2.286-.014 4.572 0 6.859-.014a.9.9 0 0 1 .813.4 421.04 421.04 0 0 0 3.175 4.238 1.08 1.08 0 0 1 .233.688c-.005 2.151 0 4.3 0 6.453 0 .577-.19.763-.766.764-.426 0-.853.014-1.278-.006-.227-.01-.307.06-.361.284a3.832 3.832 0 0 1-2.988 3.039 3.937 3.937 0 0 1-4.752-2.99c-.055-.257-.146-.336-.414-.334-2.1.013-4.2.009-6.3 0-.2 0-.313.012-.367.274a3.953 3.953 0 0 1-3.909 3.156 3.957 3.957 0 0 1-3.855-3.184c-.037-.186-.1-.256-.3-.248-.436.017-.875-.023-1.309.011a1.777 1.777 0 0 1-1.938-1.95c.039-2.119.011-4.239.011-6.359z",
    transform: "translate(1520.183 -23.397)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41151",
    d: "M-521.668 256.182v6.918c0 .232-.043.319-.3.317-1.745-.012-3.49-.008-5.236 0a.575.575 0 0 1-.414-.16 3.95 3.95 0 0 0-5.115-.069.9.9 0 0 1-.641.231q-1.418-.019-2.836 0c-.214 0-.28-.05-.28-.273q.01-6.949.006-13.9c0-.469.189-.659.667-.66h13.463c.5 0 .682.191.682.711q.005 3.442.004 6.885z",
    transform: "translate(1507.407 -35.885)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41152",
    d: "M-345.255 335.79c0-1.61 0-3.22-.005-4.83 0-.226.046-.3.289-.3q1.994.019 3.989 0c.238 0 .293.068.291.3a237.742 237.742 0 0 0 0 3.583c0 .486.193.681.676.682 1.568 0 3.137.006 4.706 0 .245 0 .314.063.312.31q-.016 2.555 0 5.11c0 .25-.071.326-.315.307-.268-.021-.579.074-.8-.032-.237-.114-.173-.476-.259-.723a3.982 3.982 0 0 0-4.093-2.669 3.945 3.945 0 0 0-3.536 3.1c-.054.255-.148.349-.406.317s-.613.107-.784-.051c-.189-.175-.061-.529-.063-.8-.006-1.437-.002-2.871-.002-4.304z",
    transform: "translate(1332.145 -111.123)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41153",
    d: "M-495.326 429.385a2.841 2.841 0 0 1 2.839-2.863 2.863 2.863 0 0 1 2.851 2.828 2.866 2.866 0 0 1-2.864 2.882 2.843 2.843 0 0 1-2.826-2.847z",
    transform: "translate(1469.676 -198.996)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41154",
    d: "M-317.654 429.358a2.88 2.88 0 0 1 2.873-2.839 2.879 2.879 0 0 1 2.842 2.869 2.885 2.885 0 0 1-2.873 2.841 2.883 2.883 0 0 1-2.842-2.871z",
    transform: "translate(1306.81 -198.994)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41155",
    d: "M-272.608 334.126h-3.826c-.139 0-.175-.049-.175-.181q.006-1.526 0-3.051c0-.145.04-.2.192-.2.363.009.727.006 1.09 0a.261.261 0 0 1 .235.116c.813 1.09 1.629 2.177 2.484 3.316z",
    transform: "translate(1269.186 -111.157)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41156",
    d: "M-415.184 440.095c.736 0 1.472.006 2.208 0 .207 0 .307.044.287.273a3.61 3.61 0 0 0 0 .621c.02.229-.08.273-.287.272q-2.037-.012-4.074 0c-.187 0-.27-.04-.3-.246a3.344 3.344 0 0 0-.218-.709c-.066-.168-.036-.211.145-.209.747.003 1.493-.002 2.239-.002z",
    transform: "translate(1398.427 -211.434)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41157",
    d: "M-535.114 440.11h1.087c.172 0 .258.019.166.225a2.568 2.568 0 0 0-.215.742c-.018.154-.1.2-.254.2-.486-.008-.973 0-1.459 0-.465-.005-.652-.2-.657-.667 0-.093.007-.187 0-.279-.015-.164.055-.217.215-.213.371-.002.744-.008 1.117-.008z",
    transform: "translate(1507.372 -211.449)",
    style: {
      fill: "#84e681"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyForPickup);
export default __webpack_public_path__ + "static/media/ReadyForPickup.3173e6c030a7a15724a0b8a8f27dcf86.svg";
export { ForwardRef as ReactComponent };